import { useEffect } from 'react';

import { ActionBar, ChakraFlex, FAIconName } from '@equip.health/ui';
import { FallbackProps } from 'react-error-boundary';

export const PatientHeaderErrorFallback = ({
  error,
  resetErrorBoundary,
}: FallbackProps) => {
  useEffect(() => {
    console.error('patient header fallback', error);
  }, []);
  return (
    <ChakraFlex
      alignItems="center"
      height="119px"
      marginLeft="20px"
      width="100%"
    >
      <ActionBar
        barIcon={FAIconName.exclamationTriangleRegular}
        buttonIcon={FAIconName.repeatRegular}
        buttonText="Refresh header"
        id="patient-header-error-fallback"
        onButtonClick={resetErrorBoundary}
        text="Unable to load the patient chart header. Please try refreshing this section."
        variant="critical"
      />
    </ChakraFlex>
  );
};
